const css = `._select_d09ln_1 {
  font-family: var(--font-date-and-tags);
}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
export default {
  "select": "_select_d09ln_1"
};